module.exports = __webpack_public_path__ + "media/images/logo-af72e199c0bff7e6b1084d39ac791232.png";